// removed by extract-text-webpack-plugin
module.exports = {"base":"Ltdi6KywEsLgODQkcTFX-","loadingText":"EQmdOx9x3ptXjc85SKSD1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OasisLoadingDataOverlay.scss
// module id = 1074
// module chunks = 0